import { Future } from '@hds/common-utils';

class ChangeEventsReadableStream {
    #_reader;
    #_readable;
    _controller;
    #_initializingFuture;
    _projection;
    constructor(projection = undefined) {
        this._projection = projection;
        this.#_initializingFuture = new Future();
    }
    /*****************************************************/
    /* START OVERRIDABLE METHODS */
    /*****************************************************/
    async _initialize() {
        this.#_readable = new ReadableStream(
            {
                //We will use the ReadableStreamDefaultController, see https://developer.mozilla.org/en-US/docs/Web/API/ReadableStreamDefaultController
                type: undefined,
                autoAllocateChunkSize: undefined,
                // This is called immediately when the object is constructed and should setup the "underlying source"
                // See https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream/ReadableStream#start
                start: (controller) => {
                    return this._start(controller)
                },
                // This will be called repeatedly when the stream's internal queue of chunks is not full, up until it reaches its high water mark. 
                // See https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream/ReadableStream#pull
                pull: (controller) => { return this._pull(controller) },
                // This method, also defined by the developer, will be called if the app signals that the stream is to be cancelled(e.g.if ReadableStream.cancel() is called).The contents should do whatever is necessary to release access to the stream source.If this process is asynchronous, it can return a promise to signal success or failure.The reason parameter contains a string describing why the stream was cancelled.
                cancel: (reason) => { return this._cancel(reason) },
            },
            {
                // this defines the total number of chunks that can be contained in the internal queue before backpressure is applied.
                // Essentially turn off backpressure for reading from the "underlying source"
                highWaterMark: Number.MAX_SAFE_INTEGER,
            }
        );
        return this.#_initializingFuture.promise;
    }
    async _start(controller) {
        this._controller = controller;
        this.#_initializingFuture.resolve();
        return this.#_initializingFuture.promise;
    }
    async _pull(controller) {
    }
    async _cancel(reason) {
        this.#_initializingFuture = null;
        return reason;
    }
    /*****************************************************/
    /* END OVERRIDABLE METHODS */
    /* START READABLE METHODS */
    /*****************************************************/
    async cancel(reason) {
        if (this.#_reader) {
            return this.#_reader.cancel(reason);
        }
        else {
            return this.#_readable.cancel(reason);
        }
    }
    getReader(options) {
        if (!this.#_reader) {
            this.#_reader = this.#_readable.getReader(options);
        }
        return this.#_reader;
    }
    pipeThrough(transformStream, options) {
        return this.#_readable.pipeThrough(transformStream, options);
    }
    async pipeTo(destination, options) {
        return this.#_readable.pipeTo(destination, options);
    }
    tee() {
        return this.#_readable.tee();
    }
    /*****************************************************/
    /* END READABLE METHODS */
    /*****************************************************/
    isInitialized() {
        return this.#_initializingFuture.isCompleted()
    }
    async whenInitialized() {
        return this._initialize();
    }
    async destroy(err) {
        this._controller.error(err);
    }
    get stream() {
        return this.#_readable;
    }
}
export { ChangeEventsReadableStream };
export default ChangeEventsReadableStream;